import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AboutMePayload } from './types';
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownLabel,
  DropdownMenu,
} from '../components/dropdown'
import {
  ArrowRightStartOnRectangleIcon,
  Cog8ToothIcon,
  WrenchScrewdriverIcon,
  UserIcon,
} from '@heroicons/react/16/solid';

import { NavbarItem } from '../components/navbar'
import { PilotAvatar, pilotInitials, pilotAvatarSrc } from './pilot_avatar'

export { pilotInitials, pilotAvatarSrc }

export const useAuthStatus = () => {
  const defaultPayload: AboutMePayload = {
      authenticated: false,
      pilot: undefined
  }
  const [userData, setUserData] = useState<AboutMePayload>(defaultPayload);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuthStatus = async () => {
      try {
        setLoading(true)
        const response = await fetch('/v0/me', { credentials: "include"});
        if (!response.ok) {
          throw new Error('Failed to fetch auth status');
        }
        const data: AboutMePayload = await response.json();
        setUserData(data)
      } catch (error) {
        console.error('Error checking auth status:', error);

        setUserData(defaultPayload);
      } finally {
        setLoading(false);
      }
    };
    checkAuthStatus();
  }, []);
  return { userData, loading };
};




export function UserDropdown() {
  const { userData } = useAuthStatus();
  const navigate = useNavigate();

  return (
    (userData.authenticated) ? (
      <Dropdown>
        <DropdownButton as={NavbarItem}>
          <PilotAvatar
            pilot={userData.pilot}
            className="size-8 bg-[#4F5D75]/20 text-[#4F5D75] dark:bg-[#BFC0C0]/20 dark:text-[#BFC0C0]"
          />
        </DropdownButton>

      <DropdownMenu className="min-w-64" anchor="bottom end">
      <DropdownItem onClick={() => navigate('/me')}>
        <UserIcon />
        <DropdownLabel>{userData.pilot?.name}'s profile</DropdownLabel>
      </DropdownItem>

      <DropdownItem onClick={() => navigate('/settings')}>
        <Cog8ToothIcon />
        <DropdownLabel>Settings</DropdownLabel>
      </DropdownItem>

      {userData.pilot?.is_admin && (
        <DropdownItem onClick={() => navigate('/admin')}>
          <WrenchScrewdriverIcon />
          <DropdownLabel>Administration</DropdownLabel>
        </DropdownItem>
      )}

      <DropdownItem href="/v0/logout">
        <ArrowRightStartOnRectangleIcon />
        <DropdownLabel>Sign out</DropdownLabel>
      </DropdownItem>

      </DropdownMenu>
      </Dropdown>
    ) : (
      <NavbarItem href="/v0/login">Log-in</NavbarItem>
    )
  )
}
